
<div class="layoutBlock">
    <div class="entrypageSideLeft"></div>

    <div class="entrypageCenter">

        <app-webtime></app-webtime>

    </div>

    <div class="entrypageSideRight"></div>
</div>
